import { render, staticRenderFns } from "./ComprehensiveDisplay.vue?vue&type=template&id=3968ee5a&scoped=true"
import script from "./ComprehensiveDisplay.vue?vue&type=script&lang=js"
export * from "./ComprehensiveDisplay.vue?vue&type=script&lang=js"
import style0 from "./ComprehensiveDisplay.vue?vue&type=style&index=0&id=3968ee5a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3968ee5a",
  null
  
)

export default component.exports